import { render, staticRenderFns } from "./ClassesLayout.vue?vue&type=template&id=b81e22a8&"
import script from "./ClassesLayout.vue?vue&type=script&lang=js&"
export * from "./ClassesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports